import React from "react";

// Section -> filename mapping (files copied to /public)
const SECTION_BG = {
  splash: "/Brand - Splash.webp",
  welcome: "/Welcome & Discovery.webp",
  auth: "/Auth Gateway.webp",
  home: "/Home Base.webp",
  search: "/Exploration Search.webp",
  identify: "/Scan & Capture.webp",
  identify_result: "/Identification Reveal.webp",
  care: "/Care & Nurturing.webp",
  diagnose: "/Health Check Scan.webp",
  diagnose_result: "/Diagnosis Revealed.webp",
  remedies: "/Healing & Remedies.webp",
  journal: "/Growth Tracking Hub.webp",
  journal_entry: "/Weekly Progress.webp",
  music: "/Frequency & Sound.webp",
  music_player: "/Zen Playback.webp",
  collection: "/My Collection - Plant History + Notifications.webp",
  notifications: "/My Collection - Plant History + Notifications.webp",
  settings: "/Personal Settings.webp",
  subscription: "/Premium + Legal ( Subscription, Payment, Upgrade Modal page).webp",
  legal: "/Premium + Legal (Legal page).webp",
};

// Brighter overlays — significantly reduced opacity, with subtle hue tints kept
const OVERLAY = {
  splash: "rgba(0,0,0,0.18)",
  welcome: "rgba(0,0,0,0.20)",
  auth: "rgba(0,0,0,0.22)",
  home: "rgba(0,0,0,0.25)",
  search: "rgba(0,0,0,0.25)",
  identify: "rgba(0,0,0,0.22)",
  identify_result: "rgba(0,0,0,0.25)",
  care: "rgba(10,8,0,0.25)",
  diagnose: "rgba(15,10,0,0.25)",
  diagnose_result: "rgba(15,10,0,0.25)",
  remedies: "rgba(0,5,0,0.20)",
  journal: "rgba(0,0,0,0.22)",
  journal_entry: "rgba(0,0,0,0.22)",
  music: "rgba(20,0,30,0.22)",
  music_player: "rgba(0,0,0,0.18)",
  collection: "rgba(0,0,0,0.25)",
  notifications: "rgba(0,0,0,0.25)",
  settings: "rgba(0,0,0,0.22)",
  subscription: "rgba(20,0,30,0.22)",
  legal: "rgba(0,0,0,0.55)",
};

export default function BackgroundLayer({ section = "home" }) {
  const url = SECTION_BG[section] || SECTION_BG.home;
  const overlay = OVERLAY[section] || "rgba(0,0,0,0.25)";
  return (
    <>
      <div
        className="bg-layer"
        style={{
          backgroundImage: `url("${url}")`,
          // Brighten image + boost saturation a touch
          filter: "brightness(1.25) saturate(1.18) contrast(1.04)",
        }}
        aria-hidden
      />
      <div className="bg-overlay" style={{ background: overlay }} aria-hidden />
    </>
  );
}
